import moment from "moment";
import { dateFormat, dbDateFormat } from "../constants/constants";

export const formatDate = (
  date?: string | Date,
  format: string = dateFormat
) => {
  return moment(date || new Date()).format(format);
};

export const formatTime = (date?: string | Date, format: string = "h:mm A") => {
  return moment(date || new Date()).format(format);
};

export const formatOnlyTime = (
  time: string,
  defaultFormat: string = "h:mm:ss",
  format: string = "h:mm A"
) => {
  return moment(time, defaultFormat).format(format);
};

export const convertMinutesToHours = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}:${remainingMinutes.toString().padStart(2, "0")}`;
};

// calculate just minutes
export const calculateMinutes = (startTime: string, endTime: string) => {
  const start = moment(startTime, "h:mm A");
  const end = moment(endTime, "h:mm A");

  return end.diff(start, "minutes");
};

export const getTimeDurationInDays = (
  startDate: string,
  endDate: string
): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const diffInMilliseconds = end.getTime() - start.getTime();
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

  return Math.round(diffInDays);
};

export const formatMinutesToHours = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

export const formatSecondToMinutes = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};

export const isExpired = (expirationDate: string, format = dbDateFormat) => {
  const currentDate = moment();
  const date = moment(expirationDate).format(format);
  return moment(date, format).isBefore(currentDate);
};

export const disableTodayAndFutureDates = (current: any) => {
  return current && current >= moment().startOf("day");
};

export const getLastTenYears = (): string[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 11 }, (_, index) =>
    (currentYear - index).toString()
  );
};

export const disableFutureDates = (current: any) => {
  return current && current.valueOf() >= Date.now();
};

export function formatShortRelativeTime(date: string | Date): string {
  const now = moment();
  const input = moment(date);
  const diffSeconds = now.diff(input, "seconds");

  if (diffSeconds < 60) return "a moment ago";

  const diffMinutes = now.diff(input, "minutes");
  if (diffMinutes < 60) return `${diffMinutes} m ago`;

  const diffHours = now.diff(input, "hours");
  if (diffHours < 24) return `${diffHours} h ago`;

  const diffDays = now.diff(input, "days");
  if (diffDays < 30) return `${diffDays} d ago`;

  const diffMonths = now.diff(input, "months");
  if (diffMonths < 12) return `${diffMonths} mo ago`;

  const diffYears = now.diff(input, "years");
  return `${diffYears} y ago`;
}
